<template>
  <div class="input-tel-box">
    <el-input placeholder="区号" v-model="value_arr[0]"></el-input>
    <span class="fr ac jc">-</span>
    <el-input placeholder="座机号" v-model="value_arr[1]"></el-input>
    <span class="fr ac jc">-</span>
    <el-input placeholder="分机号" v-model="value_arr[2]"></el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value_arr: [],
    };
  },

  watch: {
    value_arr(n) {
      let v = this.trimSpace(n);
      this.$emit("update:value", v.join("-"));
    },
    value(n) {
      if (!this.is_Empty(n)) {
        this.init(n);
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    trimSpace(array) {
      for (let i = 0; i < array.length; i++) {
        if (this.is_Empty(array[i])) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    init(n) {
      if (!this.is_Empty(this.value)) {
        this.value_arr = this.value.split("-");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input-tel-box {
  width: 100%;
  display: grid;
  grid-template-columns: 20% 5% 45% 5% 25%;
  grid-template-rows: 40px;
  line-height: 40px;

  input {
    border-bottom: 1px solid #e5e5e5;
    width: 100%;
    height: 100%;
    // line-height: 60px;
    padding-left: 5px;
    font-size: 28px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);

    &::placeholder {
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/telInput.vue